// string values taken from dom OrientationLockType
export enum CameraOrientation {
    PORTRAIT = 'portrait',
    LANDSCAPE = 'landscape',
    NONE = 'any',
}
